// extracted by mini-css-extract-plugin
export default {"root":"JNN6V4G8ay0sQjdJVOZA","content":"k7Pjwyc7LW_ILl8vByAC"};